import type { IntentGetQuoteArgs, IntentSdkContext } from '@/types/sdk/experimental/crosschain/crosschainIntentTypes'
import type { IntentGetQuoteResponse } from '@vaultsfyi/common/schemas'
import { parseIntentError } from './parseIntentError'

export const getIntentQuote = async (
  ctx: IntentSdkContext,
  { userAddress, inputToken, outputVault, amount }: IntentGetQuoteArgs
): Promise<IntentGetQuoteResponse> => {
  const response = await fetch(`${ctx.base}/intent/getQuote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userAddress,
      inputPosition: { address: inputToken.address, network: inputToken.network, amount },
      outputPosition: { address: outputVault.address, network: outputVault.network },
      feeToken: { address: inputToken.address, network: inputToken.network },
      provider: ctx.provider,
    }),
  })

  if (!response.ok) {
    const error = await parseIntentError(response, 'Failed to fetch crosschain quote')
    if (error.message === 'Insufficient balance') {
      throw new Error('Insufficient balance to cover the amount and bridge fees. Try lowering the amount.')
    }
    throw error
  }

  return response.json()
}
